import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-card-faq',
  templateUrl: './sample-card-faq.component.html',
  styleUrls: ['./sample-card-faq.component.scss']
})
export class SampleCardFaqComponent implements OnInit {

  @Input() block: any;
  @Input() isAvvisi: boolean = false;
  @Input() margin: string = '';
  public isLinkEsternal: boolean = false;
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };
  public badgeText: string = '';

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.objTitle = this.nodeService.retriveLinkTagA(this.block.field_titolo, 'a');
    this.isLinkEsternal = this.objTitle.link ? this.nodeService.verifyLinkExternal(this.objTitle.link) : false;
    this.setBadge();
  }

  public setLabelCategorySmall(category: any): string {
    let stingCategory: string = '';
    if (category.length > 3) {
      stingCategory = category[0].name + ', ' + category[1].name + ', ' + category[2].name + ', ' + '+' + (category.length - 3);
    } else {
      category.forEach((el: any, idx: number) => {
        if (idx === category.length - 1) {
          stingCategory += el.name;
        } else {
          stingCategory += el.name + ', ';
        }
      });
    }
    return stingCategory;
  }

  public setBadge(): any {
    if (this.objTitle.link.includes('faq') || this.objTitle.link.includes('procedure')) {      
      this.badgeText = this.objTitle.link.split('/')[2];
    } else {
      this.badgeText = 'faq';
    }
    if (this.badgeText === 'procedure') {
      this.badgeText = this.badgeText.replace('procedure', 'procedura');
    }
  }

}
